import type { ErrorMap } from '@/app/error-registry';

// Validation codes the widget domain can return on create and update alike
// (Widget.InvalidType only exists on create, where the type is part of the
// payload). Keeping them in one object avoids the two maps drifting apart.
const WIDGET_VALIDATION_ERRORS = {
  'Widget.EmptyTitle': 'dashboard:apiErrors.emptyTitle',
  'Widget.InvalidType': 'dashboard:apiErrors.invalidType',
  'Widget.InvalidGroupBy': 'dashboard:apiErrors.invalidGroupBy',
  'Widget.InvalidGroupByForType': 'dashboard:apiErrors.invalidGroupByForType',
  'Widget.CrossScopeReference': 'dashboard:apiErrors.crossScopeReference',
  'Widget.InvalidAggregationFunction': 'dashboard:apiErrors.invalidAggregation',
  'Widget.IncompatibleAggregation': 'dashboard:apiErrors.incompatibleAggregation',
  'Widget.MissingAggregationField': 'dashboard:apiErrors.missingAggregationField',
  'Widget.MissingPercentCondition': 'dashboard:apiErrors.missingPercentCondition',
  'Widget.InvalidLayoutWidth': 'dashboard:apiErrors.invalidLayout',
  'Widget.InvalidLayoutHeight': 'dashboard:apiErrors.invalidLayout',
  'Widget.InvalidLayoutX': 'dashboard:apiErrors.invalidLayout',
  'Widget.InvalidLayoutY': 'dashboard:apiErrors.invalidLayout',
  'Widget.InvalidConfig': 'dashboard:apiErrors.invalidConfig',
  'Dashboard.BoardNotFound': 'dashboard:apiErrors.boardNotFound',
  'Dashboard.BoardScopeMismatch': 'dashboard:apiErrors.boardScopeMismatch',
  'Dashboard.NotFound': 'dashboard:apiErrors.dashboardNotFound',
  'Dashboard.Forbidden': 'dashboard:apiErrors.forbidden',
} as const;

export const DASHBOARD_WIDGET_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    ...WIDGET_VALIDATION_ERRORS,
    default: 'dashboard:apiErrors.createDefault',
  },
};

export const DASHBOARD_WIDGET_UPDATE_ERROR_MAP: ErrorMap = {
  PUT: {
    ...WIDGET_VALIDATION_ERRORS,
    'Widget.NotFound': 'dashboard:apiErrors.widgetNotFound',
    default: 'dashboard:apiErrors.updateDefault',
  },
};

export const DASHBOARD_WIDGET_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'Widget.NotFound': 'dashboard:apiErrors.widgetNotFound',
    'Dashboard.Forbidden': 'dashboard:apiErrors.forbidden',
    default: 'dashboard:apiErrors.deleteDefault',
  },
};

export const DASHBOARD_WIDGET_REORDER_ERROR_MAP: ErrorMap = {
  PATCH: {
    'Dashboard.NotFound': 'dashboard:apiErrors.dashboardNotFound',
    'Dashboard.Forbidden': 'dashboard:apiErrors.forbidden',
    default: 'dashboard:apiErrors.reorderDefault',
  },
};
